import React, { Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowStackTraceModal } from 'redux/modules/development';
import { getShowStackTraceModal } from 'redux/selectors/development';
import { getHasAccessToDevtols } from 'redux/selectors/user';
import type { ThunkDispatch } from 'types/redux';

const StackTraceModal = lazy(() => import('./StackTraceModal'));

const StackTraceModalLoader = ({ hasNavbar = true }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const showStackTraceModal = useSelector(getShowStackTraceModal);
  const hasAccess = useSelector(getHasAccessToDevtols);

  if (!hasAccess || !showStackTraceModal) return null;

  return (
    <Suspense fallback={null}>
      <StackTraceModal
        isOpen={showStackTraceModal}
        onClose={() => {
          dispatch(setShowStackTraceModal(false));
        }}
        hasNavbar={hasNavbar}
      />
    </Suspense>
  );
};

export default StackTraceModalLoader;
